import React from 'react';
import { DropZoneBase } from './DropZoneBase';
import { DEFAULT_AUDIO_ACCERT, DEFAULT_OUTPUT_FORMAT, OUTPUT_FORMATS } from '../ai/shared/constants/outputFormats';

const DEFAULT_AUDIO_FORMATS = 'AAC, FLAC, M4A, MP3, OGG, WAV';
const DEFAULT_VIDEO_FORMATS = 'MKV, MP4, WEBM';

export const AudioDropZone = ({
    showFormatSelector,
    outputFormats = OUTPUT_FORMATS,
    defaultOutputFormat = DEFAULT_OUTPUT_FORMAT,
    defaultTemplate = null,
    onFormatChange,
    onTemplateChange,
    fileTypesDescription,
    accept = DEFAULT_AUDIO_ACCERT,
    ...otherProps
}) => {
    const computedFileTypesDescription = fileTypesDescription ?? `${DEFAULT_AUDIO_FORMATS}, ${DEFAULT_VIDEO_FORMATS}`;

    return (
        <DropZoneBase
            {...otherProps}
            className="audio"
            accept={accept}
            fileTypesDescription={computedFileTypesDescription}
            dropzoneMessage="Перетащите записи сюда или выберите файлы"
            showFormatSelector={showFormatSelector}
            outputFormats={outputFormats}
            defaultOutputFormat={defaultOutputFormat}
            defaultTemplate={defaultTemplate}
            onFormatChange={onFormatChange}
            onTemplateChange={onTemplateChange}
            recomendedMaxFileLength={"Одна запись — до 4 часов в сжатых форматах; для WAV ограничение — размер (≈ 2,5 часа)."}
            audioFormats={DEFAULT_AUDIO_FORMATS}
            videoFormats={DEFAULT_VIDEO_FORMATS}
        />
    );
};